import React from 'react';
import Typography from 'carbon-react/lib/components/typography';
import { FormattedMessage } from 'react-intl';

import { Organisation } from '@futrli-sdk/organisations';
import { Integration } from '@futrli-sdk/app-store';

import * as styles from './sync-data-card.scss';

interface Props {
  organisation: Organisation | null;
  integration?: Integration;
}

export const SyncDataOrgDetails = ({ organisation, integration }: Props) => (
  <div className={styles.imageRow}>
    <img src={integration?.image} alt={integration?.name} style={{ width: 40, height: 40 }} />
    <div>
      <Typography fontSize="16px" fontWeight="500" mb={0}>
        {organisation?.name}
      </Typography>
      <Typography variant="p" mb="0" color="rgba(0, 0, 0, 0.55)">
        <FormattedMessage
          id="predict.sync_data.integration_name"
          defaultMessage="{integration} organisation"
          values={{ integration: integration?.name }}
        />
      </Typography>
    </div>
  </div>
);
